<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1 font-weight-bolder">
          ${{ dFormatter(currentTVL) }}
        </b-card-title>
        <b-card-sub-title>Total TVL</b-card-sub-title>
      </div>
      <!-- datepicker -->
      <div class="d-flex align-items-center">
        <feather-icon
          icon="CalendarIcon"
          size="16"
        />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range'}"
          @on-close="changeTVLRange"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div>
      <!-- datepicker -->
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <vue-apex-charts
        v-if="loaded"
        :key="refresh"
        type="area"
        height="300"
        :options="apexChartData.tvlAreaChart.chartOptions"
        :series="apexChartData.tvlAreaChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BCardText,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import VueApexCharts from 'vue-apexcharts'
import apexChartData from './apexChartData'
import { dFormatter } from '@core/utils/filter'
import axios from 'axios'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardText,

    flatPickr,
    VueApexCharts,
  },
  data() {
    return {
      loaded: false,
      refresh: false,
      currentTVL: 0,
      TVLDataset: [],
      apexChartData,
      rangePicker: ['2021-08-21', '2022-08-31'],
    }
  },
  methods: {
    dFormatter,
    changeTVLRange(selectedDates, dateStr, instance) {
      apexChartData.tvlAreaChart.series[0].data = []
      for (let datapoint in this.TVLDataset){
        if(this.TVLDataset[datapoint].x >= selectedDates[0] && this.TVLDataset[datapoint].x <= selectedDates[1]){
          apexChartData.tvlAreaChart.series[0].data.push({
            x: this.TVLDataset[datapoint].x,
            y: this.TVLDataset[datapoint].y
          })
        }
      }
      this.refresh = !this.refresh
    },
  },
  mounted () {
    this.loaded = false
    // query TVL Data
    const tvlEndpoint = 'https://api.llama.fi/v2/historicalChainTvl/Near'
    axios.get(tvlEndpoint)
    .then(response => {
      this.currentTVL = response.data[response.data.length-1].tvl
      apexChartData.tvlAreaChart.series[0].data = []
      for (let datapoint in response.data){
        var x = new Date(Number(response.data[datapoint].date)*1000)
        var y = response.data[datapoint].tvl
        apexChartData.tvlAreaChart.series[0].data.push({
          x: x,
          y: y
        })
        this.TVLDataset.push({
          x: x,
          y: y
        })
      }
      this.loaded = true;
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>
